var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 9.375C38.7598 9.375 9.375 38.7598 9.375 75C9.375 111.24 38.7598 140.625 75 140.625C111.24 140.625 140.625 111.24 140.625 75C140.625 38.7598 111.24 9.375 75 9.375ZM75 129.492C44.9121 129.492 20.5078 105.088 20.5078 75C20.5078 44.9121 44.9121 20.5078 75 20.5078C105.088 20.5078 129.492 44.9121 129.492 75C129.492 105.088 105.088 129.492 75 129.492Z",
    fill: "#86C1A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.381 73.1088L62.0069 41.6147C61.659 41.3597 61.2471 41.2063 60.8172 41.1716C60.3873 41.1369 59.9562 41.2223 59.5719 41.4182C59.1876 41.6141 58.8653 41.9129 58.6409 42.2813C58.4165 42.6496 58.2987 43.073 58.3008 43.5043V106.493C58.3008 108.412 60.4688 109.496 62.0069 108.382L105.381 76.8881C105.68 76.6724 105.924 76.3885 106.092 76.0599C106.261 75.7314 106.348 75.3676 106.348 74.9985C106.348 74.6294 106.261 74.2656 106.092 73.937C105.924 73.6085 105.68 73.3246 105.381 73.1088ZM67.6465 92.7377V57.2592L92.0654 74.9985L67.6465 92.7377Z",
    fill: "#86C1A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconPlayVideo);
export default __webpack_public_path__ + "static/media/TH-Icon-Play-Video.611830eacb493c6873afb6cc56279421.svg";
export { ForwardRef as ReactComponent };